export function calculateRowTotals(milestones) {
    if (!milestones || !Array.isArray(milestones)) {
        return { totalPercentage: 0, totalValue: 0 };
    }

    const totals = milestones.reduce(
        (acc, milestone) => {
            if (milestone && milestone.percentage) {
                acc.totalPercentage += Number(milestone.percentage || 0);
            }

            if (milestone) {
                if (milestone.value) {
                    acc.totalValue += milestone.value || 0;
                } else if (milestone.amount) {
                    acc.totalValue += milestone.amount || 0;
                }
            }
            return acc;
        },
        { totalPercentage: 0, totalValue: 0 },
    );

    return {
        totalPercentage: Math.round(Number(totals.totalPercentage) * 100) / 100,
        totalValue: totals.totalValue,
    };
}
